module.exports = __webpack_public_path__ + "dist/instagram.6696828e.svg";